import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  press(event) {
    const digit = event.currentTarget.dataset.digit
    if (!digit) return

    const current = this.inputTarget.value
    const max = parseInt(this.inputTarget.getAttribute('maxlength') || '6', 10)
    if (current.length >= max) return

    this.inputTarget.value = current + digit
    this.inputTarget.focus()
  }

  clear() {
    this.inputTarget.value = this.inputTarget.value.slice(0, -1)
    this.inputTarget.focus()
  }

  submit() {
    this.element.querySelector('form').requestSubmit()
  }
}
